import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const TagsManagement = lazy(() =>
  import("@scenes/TagsManagement").then((module) => ({
    default: module.default.TagsManagement,
  }))
);

export const tagManagementNRO: NavigationRoutingObject = {
  Component: TagsManagement,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("tags-pill-menu-option", "Tag Management"),
  pageNameForTracking: () => "Tag Management",
  getDeveloperNavigationAllowed: (context) => {
    if (
      context.featureOn("clip_granular_permissions_all") &&
      context.featureOn("clip_granular_permission_manage_tags")
    ) {
      return true;
    }
    return context.hasPermission("appGroup", {
      permission: "manageTags",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("tags-settings", "Tags")],
      description: t("previously-tags", 'Previously "Tags"'),
    },
    {
      keywords: [t("email-preferences-manage-settings", "Manage Settings")],
      description: t("previously-manage-settings", 'Previously in "Manage Settings"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
